import React from "react";
import { chartImg1, chartImg2 } from "..";
const chartData = [
  {
    id: 0,
    card_name: "Smart Defense for Every Layer",
    card_para:
      "Vodote Techa integrates deep security into your tech stack, protecting from first click to final byte.",
    card_img: chartImg1,
  },
  {
    id: 1,
    card_name: "Secure Operations, Always On",
    card_para:
      "Prevent outages and data loss. Our strategy keeps your systems compliant, secure, and running strong.",
    card_img: chartImg2,
  },
];
function ChartCard() {
  return (
    <div className="row chartRow">
      {chartData.map((items, index) => (
        <div className="col-md-6 col-lg-5" key={index}>
          <div className="chartCardWrap">
            <h4>{items.card_name}</h4>
            <p>{items.card_para}</p>
            <div className="chartImgWrap">
              <img
                src={items.card_img}
                alt={items.card_name}
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChartCard;
